import React, {useEffect} from "react";
import { Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdLocalTaxi } from "react-icons/md";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"

import { getTypeDocumentsProvider } from "store/actions";
import { useDispatch } from 'react-redux';

import { useForms } from "./../../use-forms/index"
import { z } from "zod"

import { toBase64 } from "pages/registers/helpers/files-helper";

// const preprocess = (value) => (!!value ? value : undefined)
const formSchema = z.object({
  car_number: z.string()
    .nonempty("Placa de carro é obrigatório.")
    .regex(/^[A-Za-z0-9]+$/i, "Selecione uma opção"),
  cnh: z.any().refine(
    (file) => file?.length >= 1,
    "Arquivo CNH é obrigatório."
  ),
  crlv: z.any().refine(
    (file) => file?.length >= 1,
    "Arquivo CRLV  é obrigatório."
  ),
  car_photo: z.any().refine(
    (file) => file?.length >= 1,
    "Arquivo foto do carro é obrigatório."
  ),
  // wallet_validity: z.string()
  //   .nonempty("Wallet Validity key type é obrigatório."),
})

//Form step 4
function Index(props) {
  let dispatch = useDispatch();

  const {
    register,
    setValue,
    setError,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema })

  useEffect(async () => {
    clearErrors()
    dispatch(props.getTypeDocumentsProvider())

    setValue('car_number', props.form.car_number)
    // setValue('wallet_validity', props.form.wallet_validity) @to-do add after

    //Reloading provider docs files to form
    props?.form?.docs?.forEach(doc => {
      console.log('props.form.docs.forEach', doc.slug, doc.file)
      setValue(doc.slug == 'foto-veiculo' ? 'car_photo' : doc.slug, doc.file)
    })
  }, [])

  const onSubmitForm = async data => {
    console.log("on" , data)
    //post or validate data to/on api endpoint here
    localStorage.setItem('cnh', await toBase64(data.cnh[0]))
    localStorage.setItem('crlv', await toBase64(data.crlv[0]))
    localStorage.setItem('foto-veiculo', await toBase64(data.car_photo[0]))

    data.cnh = data.cnh[0]
    data.crlv = data.crlv[0]
    data['foto-veiculo'] = data.car_photo[0]
    delete data.car_photo, data.cnh, data.crlv

    data.docs = []
    Object.values(props.docs).forEach(doc => {
      const types = ['cnh', 'crlv', 'foto-veiculo']; //@to-do add -> 'foto-veiculo'
      let slug = doc.slug.toLowerCase()
      if (types.includes(slug)) {
        data.docs.push({
          document_id: doc.id,
          document_name: doc.name,
          name: data[slug]?.name || null,
          slug: slug,
          file: data[slug]
        })
      }
    })

    //on success
    props?.submit(data)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmitForm)} className="col-12 col-md-6 col-lg-4">
      <div className="background"></div>
      <h2 className="mb-3"><MdLocalTaxi/> Documentos e informações do veículo</h2>
      <p>Preencha os campos correspondentes à informações e documentação do veículo, e salve para continuar.</p>
      <Row>
        <Form.Group as={Col} className="mb-3 col-12">
          <Form.Label column sm="5">
            Placa do veículo
          </Form.Label>
          <Col sm="12">
            <Form.Control type="text" {...register('car_number')} />
            {errors.car_number?.message && <div className="text-danger">{errors.car_number?.message}</div>}
          </Col>
        </Form.Group>
        {/*
            <Form.Group>
              <Form.Label>Validade da carteira</Form.Label>
              <Form.Control type="date" {...register('wallet_validity')}/>
              {errors.wallet_validity?.message && <div className="text-danger">{errors.wallet_validity?.message}</div>}
            </Form.Group>*/}
      </Row>

      <Row>
        <Form.Group className="mb-3 col-12" >
          <Form.Label>CNH</Form.Label>
          <Form.Control type="file"  {...register('cnh')} />
          {errors.cnh?.message && <div className="text-danger">{errors.cnh?.message}</div>}
        </Form.Group>

        <Form.Group className="mb-3 col-12" >
          <Form.Label>CRLV</Form.Label>
          <Form.Control type="file"  {...register('crlv')} />
          {errors.crlv?.message && <div className="text-danger">{errors.crlv?.message}</div>}
        </Form.Group>
        
        <Form.Group className="mb-3 col-12" >
          <Form.Label>Foto do veículo</Form.Label>
          <Form.Control type="file" {...register('car_photo')} />
          {errors.car_photo?.message && <div className="text-danger">{errors.car_photo?.message}</div>}
        </Form.Group>
      </Row>

      <ButtonGroup className="col-12 mt-5">
        <Button onClick={props?.back} className="btn btn-light btn-large" type="buttom">Voltar</Button>
        <Button className="btn btn-primary btn-large centerButton" type="submit">Salvar</Button>
      </ButtonGroup>

    </Form>
  );
}


Index.PropTypes = {
  data: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {...state.Document}
};

export default withTranslation()(withRouter(connect(mapStateToProps, { getTypeDocumentsProvider })(Index)));